'use client';

import { Button } from '~/components/ui/button';

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className='bg-primary-3 text-neutral-5 flex grow flex-col'>
      <div className='mx-auto flex h-screen max-w-md flex-col justify-center gap-y-4 text-center'>
        <h1 className='text-neutral-1 mb-2 text-2xl lg:text-4xl'>Oh No!</h1>
        <p className='text-neutral-2'>
          Something went wrong. This could be a temporary issue, please try your action again.
        </p>
        <Button variant='secondary' onClick={() => reset()} className='mx-auto max-w-[175px]'>
          Try Again
        </Button>
      </div>
    </div>
  );
}
